import React from 'react';
import Icon from '../../../icon';
const TagDeleteButton = (props) => {
  const {
    selectProps: { isDisabled },
    innerProps,
  } = props;

  return (
    <button {...innerProps} className="ws-ui-base-select-tag-delete-button" disabled={isDisabled}>
      <Icon type="inherit" size="100%" glyph="clear-search" />
    </button>
  );
};

export default TagDeleteButton;
